<template>
    <Dialog :open="open" :title="$t('account.confirmPhoneNumber')" max-width="400px" @close="$emit('close')"
            @enter="confirmPhoneNumber">
        <v-form ref="form" v-model="validMail" @submit.prevent="confirmPhoneNumber">
            <v-row>
                <v-col cols="10" offset="1">
                    {{ $t('account.enterConfirmationCode') }}
                    <v-otp-input
                            ref="otpInput"
                            v-model="code"
                            length="4"
                            type="text"
                            @finish="$refs.otpInput.focus()"
                            @keyup.enter="confirmPhoneNumber"
                    ></v-otp-input>
                </v-col>
            </v-row>
            <v-row>
                <v-col class="text-right">
                    <v-btn
                            :disabled="code.length <4"
                            :loading="loading"
                            class=" py-6 accentText--text shadow-inverse"
                            color="accent"
                            depressed
                            @click="confirmPhoneNumber">
                        {{ $t('confirm') }}
                    </v-btn>
                </v-col>
            </v-row>
        </v-form>
    </Dialog>
</template>

<script>
import Dialog from "@/components/reusable/Dialog/Dialog";

export default {
  name: "PhoneConfirmationDialog",
  components: {Dialog},
  props: {
    open: {
      type: Boolean,
      required: true,
    }
  },
  mounted() {
    // this.$refs.otpInput.focus();
  },
  data() {
    return {
      validMail: false,
      loading: false,
      code: '',
    };
  },
  watch: {
    open(val) {
      if (val) {
        setTimeout(() => {
          this.$refs.otpInput.focus();
        }, 10)
      }
    }
  },
  computed: {
    organizationId() {
      return this.$store.getters.getOrganizationId;
    }
  },
  methods: {
    confirmPhoneNumber() {
      if (this.code.length < 4 || this.loading) {
        return;
      }
      this.loading = true;
      const url = this.$store.getters.getUrl('confirmPhoneNumber');
      this.axios.put(url, this.code.toString()).then(() => {
        this.$emit('close');
        this.$emit('confirmed');
        this.code = '';
        this.$store.dispatch('addNotification', {
          type: 'success',
          message: this.$t('success.phoneConfirmed'),
        });
      }).finally(() => {
        this.loading = false;
      });
    }
  }
};
</script>

<style scoped>

</style>